<template>
  <v-container class="import-city-wizard pa-0" fluid>
    <v-sheet class="import-city-wizard__hero" rounded="xl">
      <div>
            <log v-if="$model.isAdmin" target="manage_groups\ImportCity" class="inline pointer">
              <template #activator="{ props }">
                <v-icon color="primary" v-bind="props">
                  mdi-file-document
                </v-icon>
              </template>

              <template #data="{ log }">
                <v-card>
                  <v-card-text>
                    <div v-for="(task, index) in log" :key="index">
                      <div>
                        <div class="time">{{ task[0].timecreated }}</div>
                        <div v-for="(logRecord, index0) in task" :key="index0" class="message">
                          {{ logRecord.other.message }}:{{ logRecord.other.userName }}<br/>
                          Импортированы группы: {{ logRecord.other.importedGroups }}<br/>
                          Заменено расписание групп: {{ logRecord.other.replacedGroups }}
                        </div>
                      </div>
                      <v-divider v-if="index != log.length - 1" />
                    </div>
                  </v-card-text>
                </v-card>
              </template>
            </log>


        <h2 class="import-city-wizard__title">Импорт расписания сетевого города (экспериментальная возможность, будьте
          внимательны)</h2>
        <h5>Импортированное расписание будет доступно только по "внешней" ссылке <a :href="$model.wwwroot+'/blocks/manage_groups/timetable/index.php#/'" target="_blank">{{$model.wwwroot+'/blocks/manage_groups/timetable/index.php#/'}}</a></h5>
      </div>

      <div class="import-city-wizard__status">
        <v-chip v-for="item in stepItems" :key="item.key" :color="item.active ? 'primary' : 'grey-lighten-1'"
          :variant="item.active ? 'flat' : 'outlined'" size="default">
          {{ item.label }}
        </v-chip>
      </div>

      <component v-if="!restoring" :is="currentComponent" :context="wizardData" @uploaded="handleUploaded"
        @resolved="handleResolved" @restart="restart" />
      <div v-else>
        <v-skeleton-loader type="article" class="transparent"></v-skeleton-loader>
      </div>
    </v-sheet>
  </v-container>
</template>

<script>
import StepUpload from "./stepUpload.vue";
import StepMapping from "./stepMapping.vue";
import StepConfirm from "./stepConfirm.vue";


import log from "moodleDir/procollege/lib/vue/log.vue";

const defaultWizardData = () => ({
  sessionId: null,
  status: "idle",
  completed: false,
  conflicts: [],
  conflictCount: 0,
  uploadedLessons: 0,
  appliedCount: 0,
});

export default {
  name: "ImportCityWizard",
  components: {
    StepUpload,
    StepMapping,
    StepConfirm,
    log,
  },
  data() {
    return {
      currentStep: "upload",
      wizardData: defaultWizardData(),
      restoring: true,
    };
  },
  created() {
    this.restoreSession();
  },
  computed: {
    currentComponent() {
      if (this.currentStep === "mapping") {
        return "StepMapping";
      }

      if (this.currentStep === "confirm") {
        return "StepConfirm";
      }

      return "StepUpload";
    },
    stepItems() {
      return [
        { key: "upload", label: "1. Файл", active: this.currentStep === "upload" },
        { key: "mapping", label: "2. Конфликты", active: this.currentStep === "mapping" },
        { key: "confirm", label: "3. Готово", active: this.currentStep === "confirm" },
      ];
    },
  },
  methods: {
    restoreSession() {
      this.restoring = true;

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/timetable2/importCity/getCurrentCityTTSession"
        )
        .then((response) => {
          const payload = response.data ?? defaultWizardData();
          this.wizardData = { ...this.wizardData, ...payload };
          this.currentStep = this.resolveStep(payload);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        })
        .finally(() => {
          this.restoring = false;
        });
    },
    handleUploaded(payload) {
      this.wizardData = { ...this.wizardData, ...payload };
      this.currentStep = this.resolveStep(payload);
    },
    handleResolved(payload) {
      this.wizardData = { ...this.wizardData, ...payload };
      this.currentStep = this.resolveStep(payload);
    },
    restart() {
      this.wizardData = defaultWizardData();
      this.currentStep = "upload";
    },
    resolveStep(payload) {
      if (!payload?.sessionId) {
        return "upload";
      }

      if (payload.completed || payload.status === "completed") {
        return "confirm";
      }

      if ((payload.conflictCount ?? 0) > 0) {
        return "mapping";
      }

      if (payload.sessionId) {
        return "confirm";
      }

      return "upload";
    },
  },
};
</script>

<style>
.transparent {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>

<style scoped>
.import-city-wizard {
  display: grid;
  gap: 24px;
}

.import-city-wizard__hero {
  padding: 28px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background:
    radial-gradient(circle at top left, rgba(251, 191, 36, 0.16), transparent 28%),
    radial-gradient(circle at bottom right, rgba(59, 130, 246, 0.14), transparent 32%),
    linear-gradient(135deg, #fffdf7 0%, #f8fbff 56%, #eef6ff 100%);
}

.import-city-wizard__title {
  font-size: 32px;
  line-height: 1.1;
  margin: 0 0 12px;
  color: #0f172a;
}

.import-city-wizard__status {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

@media (max-width: 768px) {
  .import-city-wizard__hero {
    padding: 20px;
  }

  .import-city-wizard__title {
    font-size: 26px;
  }
}
</style>
